const Housekeeping = () => import('../views/housekeeping')

export default [
    {path:'/housekeeping',component:Housekeeping},
]